/* eslint-disable key-spacing, no-multi-spaces */
import React, { Component, PropTypes } from 'react';
import shouldPureComponentUpdate from 'react-pure-render/function';

import './Loading.scss';

export default class Loading extends Component {
  static propTypes = {
    loadingState: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    isSmall: PropTypes.bool,
    position: PropTypes.oneOf(['fixed', 'static']),
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  };

  shouldComponentUpdate = shouldPureComponentUpdate;

  render() {
    const { isSmall, loadingState, position, height } = this.props;
    const spinner = (
      <div className={`loading ${isSmall ? 'loading--small' : ''}`}>
        { loadingState === 'spinning' &&
          <div className={`loading__inner loading__inner--is-position-${position}`} />
        }
      </div>
    );
    return height ? (
      <div className="loadingContainer" style={{ height: `${height}px` }}>
        { spinner }
      </div>
    ) :
    spinner;
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Loading/Loading.jsx
 **/